module.exports = __webpack_public_path__ + "src/routes/help/data.jpg?dadfb3af";


//////////////////
// WEBPACK FOOTER
// ./src/routes/help/data.jpg
// module id = 2845
// module chunks = 1